import { httpCreate } from './http';

const http = httpCreate('/srv/photoActivity');

export const photoActivity = {
	//删除背景音乐
	delBgm(id) {
		return http.delete(`/bgm/${id}`);
	},
};
